export enum WidgetNameEnum {
	portfolio = 'portfolio',
	position = 'position',
	watchlist = 'watchlist',
	createOrder = 'createOrder',
	orders = 'orders',
	info = 'info',
	tradingView = 'tradingView',
	optionsBoard = 'optionsBoard',
}
